import {
  Command,
  GroupCommand,
  NotUndoableCommandError,
  SelectObjectsCommand,
  SetObjectsVisibilityCommand,
  Viewer,
} from '@stereograph/teiaviewer';

/**
 * @category command
 */
export class SetObjectSelectedAndVisible extends Command {
  readonly name = 'SetObjectSelectedAndVisible';
  override isUndoable = false;
  private selectedGuids: Array<string>;

  private readonly command: GroupCommand;

  constructor(viewer: Viewer, selectedGuids: Array<string>) {
    super(viewer);
    this.selectedGuids = selectedGuids;

    this.command = new GroupCommand(viewer, [
      new SetObjectsVisibilityCommand(this.viewer, this.selectedGuids, true),
      new SelectObjectsCommand(this.viewer, this.selectedGuids),
    ]);
  }

  protected override async _do(): Promise<void> {
    this.command.execute({
      addToUndoHistory: false,
      requestRender: false,
    });
  }

  protected override async _undo(): Promise<void> {
    throw new NotUndoableCommandError(this);
  }
}
